module.exports = __webpack_public_path__ + "static/img/asset.463cb8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asset.svg
// module id = bCcx
// module chunks = 1